/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { TravelItemMinimalListResponse } from '../../models/travel-item-minimal-list-response';

export interface TravelControllerGetEarliest$Params {
  categories?: Array<number>;
  tour_leaders?: Array<number>;
  countries?: Array<string>;
  limit: number;
  skip: number;
}

export function travelControllerGetEarliest(http: HttpClient, rootUrl: string, params: TravelControllerGetEarliest$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelItemMinimalListResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, travelControllerGetEarliest.PATH, 'get');
  if (params) {
    rb.query('categories', params.categories, {});
    rb.query('tour_leaders', params.tour_leaders, {});
    rb.query('countries', params.countries, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TravelItemMinimalListResponse;
      }>;
    })
  );
}

travelControllerGetEarliest.PATH = '/travel/earliest';
